import React from "react";
import { Flex, Text } from "@chakra-ui/react";
import OrderHistoryDetail from "@/features/my-order/features/order-history/components/title-section/OrderHistoryDetail";
import useOrderHistoryDetail from "@/features/my-order/features/order-history/hooks/useOrderHistoryDetail";

function OrderHistoryTitleSection(): JSX.Element {
  const { data } = useOrderHistoryDetail();

  return (
    <Flex flexDirection={"column"} gap={"8px"}>
      <Text textStyle={"heading-sm"} color={"#444444"}>
        {`#${data?.line_sheet_set.id} ${data?.line_sheet_set?.name}`}
      </Text>
      <OrderHistoryDetail />
    </Flex>
  );
}

export default OrderHistoryTitleSection;
